<template>
  <div>
    <main-layout :show-elements='true'>
      <title-banner
        :show-subtitle='true'
        :image-url='bannerImageUrl'
      />
      <b-container class="container">
        <b-breadcrumb :items='breadcrumbs' class='breadcrumb'></b-breadcrumb>
        <div class='satmed-card'>
            <b-col cols='12' class='mb-3'>
              <h3>Consulta el estado de tu caso</h3>
            </b-col>
            <b-col cols='12'>
              <b-form @submit.prevent='checkStatus'>
                <b-form-group>
                  <b-input-group prepend='Radicado:'>
                    <b-form-input
                      placeholder='Ejemplo: 20230101-999'
                      size='lg'
                      v-model='radicado'>
                    </b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group>
                  <button
                    size='lg'
                    class='satmed-btn-tertiary'
                    type='submit'>
                    Consultar
                  </button>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols='12' v-if='estado'>
              <b-card>
                <b-card-body>
                  <h4>
                    {{ estado }}
                  </h4>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols='12' v-if='error'>
              <b-card>
                <b-card-body>
                  <h3>
                    {{ error }}
                  </h3>
                </b-card-body>
              </b-card>
            </b-col>
        </div>
      </b-container>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import TitleBanner from '@/layouts/TitleBanner.vue';

const messages = {
  Recibida: 'Tu alerta ha sido recibida y dentro de poco será atendida por un gestor',
  'En gestión': 'Tu alerta se encuentra en proceso de gestión',
  Cerrada: 'Tu alerta se encuentra cerrada',
  Derivada: 'Tu alerta ha sido derivada a las secretarías, entes o entidades competentes para su atención',
  'En atención': 'Tu alerta se encuentra en proceso de atención por parte de las entidades competentes',
  Atendida: 'Tu alerta ha sido atendida por las entidades competentes',
};

export default {
  name: 'NewCase',
  components: {
    TitleBanner,
    MainLayout,
  },
  data() {
    return {
      estado: null,
      radicado: null,
      error: null,
      baseBreadcrumbs: [
        {
          text: 'Alcaldía de Medellín',
          href: 'https://www.medellin.gov.co/',
        },
        {
          text: 'SATMED',
          href: '/satmed/nuevo-caso',
        },
        {
          text: 'Consultar caso',
        },
      ],
    };
  },
  methods: {
    async checkStatus() {
      this.error = null;
      this.estado = null;
      try {
        const { data } = await this.$store.state.api.get(`alerta/${this.radicado}`);
        if (data) {
          if (data.ESTADO_ALERTA !== undefined) {
            this.estado = messages[data.ESTADO_ALERTA];
          }
        }
      } catch (err) {
        this.error = 'No se encontró un caso con ese radicado';
      }
    },
  },
  computed: {
    bannerImageUrl() {
      // eslint-disable-next-line global-require
      return require('@/assets/images/banner-formulario.jpg');
    },
    breadcrumbs() {
      return this.baseBreadcrumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1680px;
  padding: 0 3em;

  @media screen and (max-width: 992px) {
    padding: 13px 30px;
  }
}

.breadcrumb {
  background: none;
  padding: 0;
  border: none;
}

.satmed-card {
  max-width: 913px;
  margin: 2em auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 768px) {
    font-size: 1em;

    h3 {
      font-size: 1.5em;
    }

    h4 {

      font-size: 1.25em;
    }

    .card-body {
      padding: 0.5em 0.5em;
      border-radius: 15px;
    }
  }
}

.satmed-btn-tertiary {
  border-radius: 50px;
  font-size: small;
  padding: 0.5em 1em;
}
</style>
